import {
  getSearchFromHash,
  getRecordCardDataFromSearch,
} from '@project/routes/utils';
import { Card } from './Card';

export class BrowserHistoryToCardLink {
  constructor(private _card: Card) {}

  /** Создает подписку. При изменении параметров поиска в поисковой строке браузера открывается карточка, указанная в строке поиска */
  bind = () => {
    this.unbind();
    this._handleHashChange();

    window.addEventListener('hashchange', this._handleHashChange);
  };

  unbind = () => {
    window.removeEventListener('hashchange', this._handleHashChange);
  };

  private _handleHashChange = () => {
    const search = getSearchFromHash(window.location.hash);
    const cur = getRecordCardDataFromSearch(search);
    const prev = this._card.data;

    if (cur && prev && Card.isCardDataEqual(cur, prev)) {
      return;
    }

    if (cur) this._card.setCard(cur);
    else this._card.deleteCard();
  };
}
